import { TableConfig } from '@constants/table.constants';
import { GridSortItem } from '@mui/x-data-grid-pro';
import { createStore, withProps } from '@ngneat/elf';
import { withEntities } from '@ngneat/elf-entities';
import { withPagination } from '@ngneat/elf-pagination';
import { withRequestsStatus } from '@ngneat/elf-requests';
import { TablePagination } from '@store/common/pagination.model';
import { AuditOfferSupplierLightDto, AuditProposalSuppliers, AuditProposalSuppliersFilters, SupplierUnitsProposalDto } from './audit-proposal-suppliers.model';

export interface AuditProposalSuppliersState {
  filters: AuditProposalSuppliersFilters;
  sort: GridSortItem;
  tablePagination: TablePagination;
  auditsProposalSupplierDetails?: AuditProposalSuppliers;
  allAuditsOfferSupFromProposalSup?: AuditOfferSupplierLightDto[];
  allAuditsSupProposal?: SupplierUnitsProposalDto[];
}

export const auditProposalSuppliersStore = createStore(
  { name: 'auditProposalSupplier' },
  withEntities<AuditProposalSuppliers>(),
  withProps<AuditProposalSuppliersState>({
    filters: {search: '', tableFilters: AuditProposalSuppliersFilters.initTableFilters()},
    sort: {
      field: 'organisation.name',
      sort: 'asc',
    },
    tablePagination: {
      page: 1,
      limit: TableConfig.pagination,
    },
  }),
  withPagination(),
  withRequestsStatus()
);
